module.exports = __webpack_public_path__ + "static/img/0542_6.593e731.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0542_6.jpg
// module id = CHb1
// module chunks = 1